export default __webpack_public_path__ + "static/media/deposit.64bbfb9e.svg";